const mutations = {
    set(state, settings) {
        state.general = settings;
    }
};
export default mutations;
